module.exports = __webpack_public_path__ + "static/media/drag-drop.da8530e8.svg";